import React from 'react';
import HSL from '@haptik/helpers/build/esm/hslBuilder';
import { BASE_URL } from '@src/const';
import { FEATURE_FLAG_DATA } from '@src/constants/MogamboConstants';
import CommonStore from '@src/stores/CommonStore';
import BotStore from '@src/store';
import QuickReply from './QuickReply';

const BotSaysBody = ({
  value,
  allPlatforms = [],
  onAddQuickReply,
  onDeleteQuickReply,
  onEditQuickReply,
  onKeyUpQuickReply,
  entities,
  onQuickRepliesRef,
  noVariants,
  noQuickReplies,
  blurred,
  blurMessage,
  DOMRef,
  onVariantsChange,
  onSupportedPlatformsChange,
  jsonPickerButton,
  isTranslated,
  channelName,
  currentBotSaysLanguage,
}) => {
  const supportedPlatforms = value.devicePlatformMap || [];
  const domainData = CommonStore.getMetaTags().domain;
  const isRephraseEnabled = BotStore.getFeatureFlag(
    FEATURE_FLAG_DATA.FLAGS.ENABLE_REPHRASE_RESPONSES
  );
  const domain = domainData.title;
  const entityURL = `${BASE_URL}/entities/search?term=&search_type=bot&bot_name=${domain}`;
  const entitySearchURL = {
    search: encodeURI(entityURL),
    map: encodeURI(`${BASE_URL}/entities/entity_mapper`),
  };
  const globalConstantsURL = `${BASE_URL}/bot/${domainData.id}/globalconstants`;

  return (
    <div
      className={`bot-says-body ${blurred ? 'blurred' : ''}`}
      data-blur-message={blurMessage}
      ref={DOMRef}
    >
      <div className="variants">
        <HSL
          value={noVariants ? value.variants?.[0] || [] : value.variants || []}
          withVariants={!noVariants}
          withReplies
          entities={entities}
          allPlatforms={allPlatforms}
          supportedPlatforms={supportedPlatforms}
          onSupportedPlatformsChange={onSupportedPlatformsChange}
          entitySearchURL={entitySearchURL}
          jsonPickerButton={jsonPickerButton}
          onChange={(data) =>
            noVariants ? onVariantsChange([data]) : onVariantsChange(data)
          }
          channelsEnabled={['whatsapp']}
          isTranslated={isTranslated}
          currentChannelName={channelName}
          displayGlobalConstantSelect
          globalConstantsURL={globalConstantsURL}
          isRephraseEnabled={
            isRephraseEnabled && currentBotSaysLanguage === 'en'
          }
          baseUrl={BASE_URL}
        />
      </div>

      {!noQuickReplies ? (
        <div className="quick-replies">
          <QuickReply
            text="+ add quick reply"
            DOMRef={(DOMElement) => onQuickRepliesRef(-1, DOMElement)}
            className="clickable disable-highlight"
            onClick={onAddQuickReply}
            tabDisabled={blurred}
          />
          {!!value.quickReplies?.length &&
            value.quickReplies.map((quickReply, i) => (
              <QuickReply
                DOMRef={(DOMElement) => onQuickRepliesRef(i, DOMElement)}
                text={quickReply}
                key={i}
                onEdit={(newVal) => onEditQuickReply(i, newVal)}
                onDelete={onDeleteQuickReply}
                onKeyUp={onKeyUpQuickReply}
                tabDisabled={blurred}
              />
            ))}
        </div>
      ) : null}
    </div>
  );
};

export default BotSaysBody;
